import { useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';

export function useSyncIdQuery(id?: string) {
  const [searchParams, setSearchParams] = useSearchParams();

  useEffect(() => {
    if (!id) return;
    if (searchParams.get('id') === id) return;

    const next = new URLSearchParams(searchParams);
    next.set('id', id);
    setSearchParams(next, { replace: true });
  }, [id, searchParams, setSearchParams]);
}

